import { UIText2 } from '@cian/ui-kit';

import styles from './TimeLabel.css';

interface ITimeLabelProps {
  added: string;
  humanizedTime: string;
}

export const TimeLabel = (props: ITimeLabelProps) => {
  return (
    <div className={styles['time-label']}>
      <div className={styles['relative']}>
        <UIText2 color="gray60_100">{props.humanizedTime}</UIText2>
      </div>
      <div className={styles['absolute']}>
        <UIText2 color="gray60_100">{props.added}</UIText2>
      </div>
    </div>
  );
};
